import "../styles/stories.css";
import { motion } from "framer-motion";
export default function Stories() {
    const handleGoBack = () => {
        window.history.back();
    };

    return (
        <div className="container-fluid storiespage-container">
            {/* 🌟 HERO SECTION */}
            <motion.section
              className="text-center d-flex align-items-center justify-content-center mb-4"
              style={{ minHeight: "20vh", background: "#0b2747", color: "white", padding: "30px 20px" }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <div className="container">
                <motion.h1 className="display-4 fw-bold" initial={{ y: -50 }} animate={{ y: 0 }} transition={{ duration: 1 }}>
                  Porvaall Stories
                </motion.h1>
                <motion.p className="lead mt-3" initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.3, duration: 1 }}>
                  Inspiring knowledge. Empowering minds. Connecting ideas.
                </motion.p>
              </div>
            </motion.section>
            <div className="container text-center">
            <h1 className="my-4">Currently Not Available . Coming Soon</h1>
            <button className="view-btn btn-lg" onClick={handleGoBack}>
                Go Back
            </button>
            </div>
        </div>
    );
}